import { FaCaretRight, FaCaretDown } from 'react-icons/fa6';

export const ToggleCaret = ({ open, size, onClick }) => {
  const icon = open ? FaCaretDown : FaCaretRight;
  return icon({ size });
};
